import { useEffect } from 'react';
import { useIdleTimerContext } from 'react-idle-timer';

export const usePauseIdleTimer = () => {
  const idleTimerContext = useIdleTimerContext();
  // workaround to fix eslint@typescript-eslint/unbound-method
  const pause = idleTimerContext.pause.bind(idleTimerContext);
  const start = idleTimerContext.start.bind(idleTimerContext);

  useEffect(() => {
    pause();
    return () => {
      start();
    };
  }, [pause, start]);
};
